// components/HomeScreen.tsx
'use client';

// import { FeedHome } from '@ninjacart/nc-nk-app';
import { Home } from '@ninjacart/nc-nk-home';
import { YStack } from '@ninjacart/nc-nk-ui';


// const Home = dynamic(() => import('@ninjacart/nc-nk-home').then(mod => mod.Home), {
//   ssr: true,
// });
// import { HomePlaceHolder } from '@ninjacart/nc-nk-ui';
// import { Suspense } from 'react';
// import { useState } from 'react';
// import SplashScreen from './splashScreen';

// const FeedHome = dynamic(() => import('@ninjacart/nc-nk-app').then((mod) => mod.FeedHome), {
//   loading: () => HomePlaceHolder(),
//   ssr: false,
// });

// const HomePlaceHolder = dynamic(
//   () => import('@ninjacart/nc-nk-ui').then((mod) => mod.HomePlaceHolder),
//   {
//     ssr: false,
//   }
// );

const HomeWithSplash = ({ initialData }: { initialData?: any }) => {
  // const [loading, setLoading] = useState(true);
  // console.log("🚀 ~ HomeWithSplash ~ fetchHomeFeedSSR:", initialData)
  return (
    <>
      <YStack fullscreen flexDirection="row" bg="$background">
        <YStack flex={1}>
          {/* <FeedHome /> */}
          <Home initialData={initialData} />
        </YStack>
      </YStack>
      {/* <FeedHome /> */}
    </>
  );
};

export default HomeWithSplash;
